<template>
    <v-container class="page-not-found-container">
        <div class="mt-6 pt-6 text-center">
            <h1>Page Not Found</h1>
            <div>
                <v-btn color="primary" @click="onReturnHome">Go To Home</v-btn>
            </div>
        </div>       
    </v-container>
</template>

<script>
    export default {
        name: 'PageNotFound',
        methods: {
            onReturnHome() {
                this.$router.push({ name: 'Home'});
            }
        }
    }
</script>
